import type { NavMenuItem } from '@/types';

import { AVIATOR_GAME_ID } from '../aviator';
import { routes } from '../routes';

export const aviatorNavMenuItem: NavMenuItem = {
  key: 'header.navigation.aviator',
  text: 'aviator',
  type: 'aviator',
  href: {
    pathname: routes.casino.game,
    query: { gameId: AVIATOR_GAME_ID },
  },
};

export const buyBonusNavMenuItem: NavMenuItem = {
  key: 'header.navigation.buy_bonus',
  text: 'Buy bonus',
  type: 'buy_bonus',
  href: {
    pathname: routes.casino.category,
    query: { category: 'bonus_buy' },
  },
};

export const casinoMenuItem: NavMenuItem = {
  key: 'header.navigation.casino_home',
  text: 'casino',
  href: routes.casino.home,
};

export const liveCasinoMenuItem: NavMenuItem = {
  key: 'header.navigation.live_casino.home',
  text: 'live casino',
  href: routes.liveCasino.home,
};

export const tournamentsMenuItem: NavMenuItem = {
  key: 'header.navigation.tournaments',
  text: 'tournaments',
  href: routes.tournaments.home,
};

// const pokerMenuItem = {
//   key: 'header.navigation.poker',
//   text: 'poker',
//   href: routes.poker.home,
// };

export const sportMenuItem: NavMenuItem = {
  key: 'header.navigation.sport.home',
  href: routes.sport.home,
  text: 'Sport',
  strictlyHighlightedOnUrl: '/sport?st=PREGAME',
};

export const cyberSportMenuItem: NavMenuItem = {
  key: 'header.navigation.cybersport.home',
  href: routes.esports.home,
  text: 'Cybersport',
};

export const sportLiveMenuItem: NavMenuItem = {
  key: 'header.navigation.sport.live',
  href: {
    pathname: routes.sport.home,
    query: { st: 'LIVE' },
  },
  text: 'Live',
};
